import { TextFields } from '@mui/icons-material';
import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

type CreateEntityTableProps = {
  csvEntities: Array<Record<string, string>>;
  loading: boolean;
  modalCtx?: { closeModal: () => void } | null;
  onEditCsvEntities: () => void;
  onCancelTableMode: () => void;
  onCreateMultipleEntities: () => void;
};

export function CreateEntityTable({
  csvEntities,
  loading,
  modalCtx,
  onEditCsvEntities,
  onCancelTableMode,
  onCreateMultipleEntities,
}: CreateEntityTableProps) {
  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">
          Creating {csvEntities.length} entities from CSV
        </Typography>
        <Stack direction="row" gap={1}>
          <Button
            onClick={onEditCsvEntities}
            size="small"
            startIcon={<TextFields />}
          >
            Edit CSV
          </Button>
          <Button onClick={onCancelTableMode} size="small">
            Back to Form
          </Button>
        </Stack>
      </Stack>

      <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {Object.keys(csvEntities[0] || {}).map((column) => (
                <TableCell key={column}>{column}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {csvEntities.map((row, index) => (
              <TableRow key={index}>
                {Object.values(row).map((value, cellIndex) => (
                  <TableCell key={cellIndex}>{value}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Stack direction="row" justifyContent="flex-end" gap={1}>
        <Button color="error" onClick={() => modalCtx?.closeModal()}>
          Cancel
        </Button>
        <Button
          disabled={loading}
          variant="outlined"
          onClick={onCreateMultipleEntities}
        >
          Create {csvEntities.length} Entities
        </Button>
      </Stack>
    </Stack>
  );
}
